import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import { useNavigate, useParams } from "react-router-dom";

import api from '../services/api';
import '../styles/floatingForm.css';
import { toast } from 'react-toastify';

const ShowApprovePackage = () => {

  const { id } = useParams();
  const navigate = useNavigate();
const [cardById, setCardById] = useState(null);
const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState('');
  // --- Data lists ---
  const [producttype, setProducttype] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [departureCities, setDepartureCities] = useState([]);
  const [airlinesList, setAirlinesList] = useState([]);
  const [faqs, setFaqs] = useState([]);

  // --- Form fields ---
  const [packageName, setPackageName] = useState('');
  const [selectedProducttype, setSelectedProducttype] = useState('');
  const [selectedVendor, setSelectedVendor] = useState('');
  const [price, setPrice] = useState('');
  const [price_discount, setPrice_discount] = useState('');
  const [highlights, setHighlights] = useState('');
  const [included, setIncluded] = useState('');
  const [notIncluded, setNotIncluded] = useState('');
  const [requirement, setRequirement] = useState('');
  const [bookingPolicy, setBookingPolicy] = useState('');
  const [cancellationPolicy, setCancellationPolicy] = useState('');
  const [roomSharing, setRoomSharing] = useState('');
  const [roomDetails, setRoomDetails] = useState('');
  const [departurePoint, setDeparturePoint] = useState('');
  const [departureDate, setDepartureDate] = useState('');
  const [departureDetails, setDepartureDetails] = useState('');
  const [arrivalPoint, setArrivalPoint] = useState('');
  const [arrivalDate, setArrivalDate] = useState('');
  const [arrivalDetails, setArrivalDetails] = useState('');
  const [departureAirline, setDepartureAirline] = useState('');
  const [arrivalAirline, setArrivalAirline] = useState('');
  const [daysDetails, setDaysDetails] = useState('');
  const [visa, setVisa] = useState('');
  const [visaDetails, setVisaDetails] = useState('');
  const [transfer, setTransfer] = useState('');
  const [transferDetails, setTransferDetails] = useState('');
  const [food, setFood] = useState('');
  const [foodDetails, setFoodDetails] = useState('');
  const [sightseeing, setSightseeing] = useState('');
  const [sightseeingDetails, setSightseeingDetails] = useState('');
  const [kabahotelname, setkabahotelname] = useState('');
  const [distanceFromKaba, setDistanceFromKaba] = useState('');
  const [kabawalkdis,setkabawalkdis]= useState('');
  const [kabacar,setkabacar] = useState('');
  const [kabahotelnameimg,setkabahotelnameimg] = useState('');
  const [kabaDetails, setKabaDetails] = useState('');

  const [rawdahotelname, setrawdahotelname] = useState('');
  const [rawdawalkdis,setrawdawalkdis]= useState('');
  const [distanceFromRawda, setDistanceFromRawda] = useState('');
  const [rawdacar,setrawdacar] = useState('');
  const [rawdahotelnameimg,setRawdahotelnameimg] = useState('');

  const [rawdaDetails, setRawdaDetails] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [bannerImageFile, setBannerImageFile] = useState(null);
  const [lastBookingDate, setLastBookingDate] = useState('');

  // --- Fetch dropdown data ---
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productRes, vendorRes, departureRes, airlineRes] = await Promise.all([
          api.get('/page/get-all'),
          api.get('/vendor/get-all'),
          api.get('/departurecities/get-all'),
          api.get('/airlines/get-all'),
        ]);

        setProducttype(productRes.data.data || []);
        setVendors(vendorRes.data.data || []);
        setDepartureCities(Array.isArray(departureRes.data.data) ? departureRes.data.data : []);
        setAirlinesList(airlineRes.data.data || []);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);
  // --- Map IDs → Names (IMPLEMENTED FIX) ---
  useEffect(() => {
    if (!cardById) return;
    console.log('Mapping cardById to form fields:', cardById);
    setPackageName(cardById.packagename || '');
    setPrice(cardById.price || '');
    setPrice_discount(cardById.price_discount || '');
    setHighlights(cardById.highlights || '');
    setIncluded(cardById.included || '');
    setNotIncluded(cardById.not_included || '');
    setRequirement(cardById.requirement || '');
    setBookingPolicy(cardById.booking_policy || '');
    setCancellationPolicy(cardById.cancellation_policy || '');
    setRoomSharing(cardById.room_sharing || '');
    setRoomDetails(cardById.room_details || '');
    setDepartureDate(cardById.departure_date || '');
    setLastBookingDate(
      cardById.lastbookingdate
      ? cardById.lastbookingdate.split(' ')[0] : '');
    setDepartureDetails(cardById.departure_details || '');
    setArrivalDate(cardById.arrival_date || '');
    setArrivalDetails(cardById.arrival_details || '');
    setDaysDetails(cardById.days_details || '');
    setVisa(cardById.visa || '');
    setVisaDetails(cardById.visa_details || '');
    setTransfer(cardById.transfer || '');
    setTransferDetails(cardById.transfer_details || '');
    setFood(cardById.food || '');
    setFoodDetails(cardById.food_details || '');
    setSightseeing(cardById.sightseeing || '');
    setSightseeingDetails(cardById.sightseeing_details || '');
    setDistanceFromKaba(cardById.distance_from_kaba || '');
    setKabaDetails(cardById.kaba_details || '');
    setkabahotelname(cardById.kabahotelname);
    setkabawalkdis(cardById.kabawalkdis);
    setkabacar(cardById.kabacar);
    setkabahotelnameimg(cardById.kabahotelnameimages)
    setRawdaDetails(cardById.kaba_details || '');
    setrawdahotelname(cardById.rawdahotelname);
    setrawdawalkdis(cardById.rawdawalkdis);
    setrawdacar(cardById.rawdacardis);
    setRawdahotelnameimg(cardById.rawdahotelnameimages)
    setDistanceFromRawda(cardById.distance_from_rawda || '');
    setRawdaDetails(cardById.rawda_details || '');
    setImageFile(cardById.image_path || null);
    setBannerImageFile(cardById.banner_image_path || null);
    

    setSelectedProducttype(
      producttype.find(p => p.id === cardById.category_id)?.name || cardById.category_id
    );

    setSelectedVendor(
      vendors.find(v => v.id === cardById.vendor_id)?.name || cardById.vendor_id
    );

    // ✅ FIXED HERE
    setDeparturePoint(
      departureCities.find(c => c.id === cardById.departure_point)?.dcityname || cardById.departure_point
    );

    setArrivalPoint(
      departureCities.find(c => c.id === cardById.arrival_point)?.dcityname || cardById.arrival_point
    );

    setDepartureAirline(
      airlinesList.find(a => a.id === cardById.departure_airline)?.airline_name || cardById.departure_airline
    );

    setArrivalAirline(
      airlinesList.find(a => a.id === cardById.arrival_airline)?.airline_name || cardById.arrival_airline
    );

  }, [cardById, producttype, vendors, departureCities, airlinesList]);

  const toggle = id => setOpen(open === id ? '' : id);

const fetchProductFaqs = async (productId) => {
  if (!productId) return;

  try {
    const res = await api.get(`/product/getcardfaqbyid/${productId}`);

    const list = res.data?.data || [];

    setFaqs(
      list.map((f) => ({
        id: f.id,
        question: f.faq_que || "",
        answer: f.faq_ans || "",
      }))
    );
  } catch (err) {
    console.error("FAQ fetch failed", err);
  }
};
  

  // --- Approve ---
  const handleSubmit = async () => {
    try {
      const response = await api.post(`/product/updateapprove/${cardById.id}`, {
        is_approved: 1,
      });

      if (response.data.status === 'success') {
        toast.success('Package approved successfully!');
      } else {
        toast.error('Failed to approve package');
      }
    } catch (error) {
      toast.error('Error approving package');
    }
  };

  useEffect(() => {
  if (id) {
    fetchProductFaqs(id);
  }
}, [id]);

   useEffect(() => {
      fetchPackage();
    }, [id]);

    const fetchPackage = async () => {
      try {
        const response = await api.get(`/product/get/${id}`);

        setCardById(response.data.data);
      } catch (error) {
        console.error("Error fetching package:", error);
      } finally {
        setLoading(false);
      }
    };

   // --- Dis Approve ---
  const handleDisapprove = async () => {
    if (!window.confirm("Are you sure you want to disapprove this package?")) return;

    try {
      const response = await api.post(`/product/updateapprove/${cardById.id}`, {
        is_approved: 0,
      });

      if (response.data.status === 'success') {
        toast.success('Package disapproved successfully!');
      } else {
        toast.error('Failed to disapprove package');
      }
    } catch (error) {
      toast.error('Error disapproving package');
    }
  };

  return (
    <div
      className="floating-form-container"
      style={{
        background: '#fbf7f4',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      }}
    >
      <div className="heading">
        <h2>Package Details</h2>
      </div>

      {/* --- First Section (basic details) --- */}
      <div className="form-container">
        <div className="section-1 mt-3">
          <div className="row">
            <div className="input-container-floating-form col-md-4">
              <label>Pilgrimage Type</label>
              <input type="text" className="form-control" value={selectedProducttype} readOnly />
            </div>
            <div className="input-container-floating-form col-md-4">
              <label>Package Name</label>
              <input type="text" className="form-control" value={packageName} readOnly />
            </div>
            <div className="input-container-floating-form col-md-4">
              <label>Service Provider</label>
              <input type="text" className="form-control" value={selectedVendor} readOnly />
            </div>
          </div>

          <div className="row">
            <div className="input-container-floating-form col-md-6 mt-3">
              <label>Price</label>
              <input type="number" className="form-control" value={price} readOnly />
            </div>
            <div className="input-container-floating-form col-md-6 mt-3">
              <label>Discount Price (%)</label>
              <input type="number" className="form-control" value={price_discount} readOnly />
            </div>
          </div>
        </div>

                {/* Departure Accordion */}
        <div className="w-100 mt-3" >
          <Accordion open={open} toggle={toggle} >
            <AccordionItem>
              <AccordionHeader targetId="Departure">Departure Details</AccordionHeader>
              <AccordionBody accordionId="Departure">
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="input-container-floating-form">
                      <label>Departure Point</label>
                      <input className="form-control" value={departurePoint} readOnly />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-container-floating-form">
                      <label>Departure Date</label>
                      <input type="date" className="form-control" value={departureDate} readOnly />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-container-floating-form">
                      <label>Departure Airline</label>
                      <input className="form-control" value={departureAirline} readOnly />
                    </div>
                  </div>
                </div>
                  <div className="col-md-4">
                    <div className="input-container-floating-form">
                      <label>Last Booking Date</label>
                      <input type="date" className="form-control" value={lastBookingDate} readOnly />
                    </div>
                  </div>
                <div className="input-container-floating-form wid-100 mt-3">
                  <label>Departure Description</label>
                  <ReactQuill value={departureDetails} readOnly theme="bubble" />
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>
        
        {/* Arrival Accordion */}
        <div className="w-100 mt-3">
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="Arrival">Arrival Details</AccordionHeader>
              <AccordionBody accordionId="Arrival">
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="input-container-floating-form">
                      <label>Arrival Point</label>
                      <input className="form-control" value={arrivalPoint} readOnly />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-container-floating-form">
                      <label>Arrival Date</label>
                      <input type="date" className="form-control" value={arrivalDate} readOnly />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-container-floating-form">
                      <label>Arrival Airline</label>
                      <input className="form-control" value={arrivalAirline} readOnly />
                    </div>
                  </div>
                </div>
                <div className="input-container-floating-form wid-100 mt-3">
                  <label>Arrival Description</label>
                  <ReactQuill value={arrivalDetails} readOnly theme="bubble" />
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>
        
        {/* Visa Accordion */}
        <div className="w-100 mt-3">
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="visa-details">Visa Details</AccordionHeader>
              <AccordionBody accordionId="visa-details">
                <div className="input-container-floating-form wid-50 mb-3">
                  <label>Visa</label>
                  <input type="text" className="form-control" value={visa} readOnly />
                </div>
                <div className="input-container-floating-form w-100">
                  <label>Visa Description</label>
                  <ReactQuill value={visaDetails} readOnly theme="bubble" />
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>
        
        {/* Room Accordion */}
        <div className="w-100 mt-3">
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="room-details">Room Details</AccordionHeader>
              <AccordionBody accordionId="room-details">
                <div className="input-container-floating-form wid-50 mb-3">
                  <label>Room Sharing</label>
                  <input type="text" className="form-control" value={roomSharing} readOnly />
                </div>
                <div className="input-container-floating-form w-100">
                  <label>Room Description</label>
                  <ReactQuill value={roomDetails} readOnly theme="bubble" />
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>

        <div className="w-100 mt-3">
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="Arrival1">Kaba Hotel Details</AccordionHeader>
              <AccordionBody accordionId="Arrival1">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="input-container-floating-form">
                      <label>Kaba Hotel Name</label>
                      <input type="text" className="form-control" value={kabahotelname} readOnly />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="input-container-floating-form">
                      <label>Distance (In Km)</label>
                      <input type="text" className="form-control" value={distanceFromKaba} readOnly />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="input-container-floating-form">
                      <label>Walk Distance (In Km)</label>
                      <input type="text" className="form-control" value={kabawalkdis} readOnly />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="input-container-floating-form">
                      <label>Car Distance (In Km)</label>
                      <input type="text" className="form-control" value={kabacar} readOnly />
                    </div>
                  </div>
                    <div className="input-container-floating-form">
                      <label>Kaba Hotel Images</label>
                      {cardById?.kabahotelnameimages ? (
                        <img
                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${cardById.kabahotelnameimages}`}
                          alt="Banner"
                          className="img-fluid"
                          style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: "8px" }}
                        />
                      ) : (
                        <p className="text-muted">No Banner Image</p>
                      )}
                    </div>
                </div>
                <div className="input-container-floating-form wid-100 mt-3">
                  <label>Kaba Description</label>
                  <ReactQuill value={kabaDetails} readOnly theme="bubble" />
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>

        <div className="w-100 mt-3">
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="Arrival12">Rawda Hotel Details</AccordionHeader>
              <AccordionBody accordionId="Arrival12">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="input-container-floating-form">
                      <label>Kaba Hotel Name</label>
                      <input type="text" className="form-control" value={rawdahotelname} readOnly />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="input-container-floating-form">
                      <label>Distance (In Km)</label>
                      <input type="text" className="form-control" value={distanceFromRawda} readOnly />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="input-container-floating-form">
                      <label>Walk Distance (In Km)</label>
                      <input type="text" className="form-control" value={rawdawalkdis} readOnly />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="input-container-floating-form">
                      <label>Car Distance (In Km)</label>
                      <input type="text" className="form-control" value={rawdacar} readOnly />
                    </div>
                  </div>
                    <div className="input-container-floating-form">
                      <label>Rawda Hotel Images</label>
                      {cardById?.rawdahotelnameimages ? (
                        <img
                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${cardById.rawdahotelnameimages}`}
                          alt="Banner"
                          className="img-fluid"
                          style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: "8px" }}
                        />
                      ) : (
                        <p className="text-muted">No Banner Image</p>
                      )}
                    </div>
                </div>
                <div className="input-container-floating-form wid-100 mt-3">
                  <label>Kaba Description</label>
                  <ReactQuill value={rawdaDetails} readOnly theme="bubble" />
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>

          {/* Section - Sightseeing */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="sightseeing-details">Sightseeing Details</AccordionHeader>
                <AccordionBody accordionId="sightseeing-details">

                  {/* Sightseeing Input */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label>Sightseeing </label>
                        <input
                          type="text"
                          className="form-control"
                          value={sightseeing}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  {/* Sightseeing Description (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Sightseeing Description</label>
                    <ReactQuill
                      theme="snow"
                      value={sightseeingDetails}
                      readOnly
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Food */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="food-details">Food Details</AccordionHeader>
                <AccordionBody accordionId="food-details">

                  {/* Food Input */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label>Food</label>
                        <input
                          type="text"
                          className="form-control"
                          value={food}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  {/* Food Details (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Food Description</label>
                    <ReactQuill
                      theme="snow"
                      value={foodDetails}
                      readOnly
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Transfer */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="transfer-details">Transfer Details</AccordionHeader>
                <AccordionBody accordionId="transfer-details">

                  {/* Transfer Input */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label>Transfer</label>
                        <input
                          type="text"
                          className="form-control"
                          value={transfer}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  {/* Transfer Details (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Transfer Description</label>
                    <ReactQuill
                      theme="snow"
                      value={transferDetails}
                      readOnly
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>
        
        {/* Generic Sections (Kaba, Rawda, etc.) */}
        {[
          { title: "Highlights", value: highlights },
          { title: "Included Details", value: included },
          { title: "Not Included Details", value: notIncluded },
          { title: "Requirements Details", value: requirement },
          { title: "Booking Policy Details", value: bookingPolicy },
          { title: "Cancellation Policy Details", value: cancellationPolicy }
        ].map((section, idx) => (
          <div key={idx} className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId={`section-${idx}`}>{section.title}</AccordionHeader>
                <AccordionBody accordionId={`section-${idx}`}>
                  <div className="input-container-floating-form w-100">
                    <ReactQuill  value={section.value} readOnly theme="bubble" style={{ fontSize: "25px", lineHeight: "1.6", color: "#333" }}/>
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>
        ))}
        
        {/* Images Accordion */}
        <div className="w-100 mt-3">
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="images-details">
                Package & Banner Images
              </AccordionHeader>
              <AccordionBody accordionId="images-details" style={{ background: "#fbf7f4" }}>
                <div className="row g-3">
                  {/* Package Image */}
                  <div className="col-md-6">
                    <div className="input-container-floating-form">
                      <label>Package Image</label>
                      {cardById?.image_path ? (
                        <img
                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${cardById.image_path}`}
                          alt="Package"
                          className="img-fluid"
                          style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: "8px" }}
                        />
                      ) : (
                        <p className="text-muted">No Package Image</p>
                      )}
                    </div>
                  </div>
        
                  {/* Banner Image */}
                  <div className="col-md-6">
                    <div className="input-container-floating-form">
                      <label>Banner Image</label>
                      {cardById?.banner_image_path ? (
                        <img
                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${cardById.banner_image_path}`}
                          alt="Banner"
                          className="img-fluid"
                          style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: "8px" }}
                        />
                      ) : (
                        <p className="text-muted">No Banner Image</p>
                      )}
                    </div>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>

                {/* FAQ SAME STYLE */}

        <div className="w-100 mt-3">
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="faq-details">
                FAQ Details
              </AccordionHeader>
              <AccordionBody accordionId="faq-details">
                {faqs.map((faq, i) => (
                  <div key={i} className="mb-3">
                    <div><strong>Question :</strong> {faq.faq_que}</div>
                    <div><strong>Answer :</strong> {faq.faq_ans}</div>
                    <hr className="form-rule" />
                  </div>
                ))}
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>
        {/* Approve / Cancel Buttons */}
        <div className="form-btn-container mt-4">
          <button type="button" onClick={handleSubmit}>
            Approve
          </button>

          <button
            type="button"
            onClick={handleDisapprove}
            style={{ background: '#dc3545', color: '#fff', marginLeft: '10px' }}
          >
            Disapprove
          </button>

          <button
            type="button"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShowApprovePackage;
